import { gsap, scrollSmootherInstance, ScrollTrigger } from "../globals/gsap";
// import imagesLoaded from "imagesloaded";
import { imagesLoaded } from "../utils/imagesLoaded";

import Header from "../globals/header";
import Sticky from "../components/sticky";
import Toplink from "../components/toplink";
import Mosaic from "../components/mosaic";
import ScrollAnimations from "../components/scrollAnimations";
import Video from "../components/video";
import Filter from "../components/filter";
import Form from "../components/form";
import Vimeo from "../components/vimeo";

import FullscreenIntro from "../components/fullscreenIntro";

class Default {
  videos = [];
  form = null;

  beforeLeave(data) {
    scrollSmootherInstance.paused(true);
    // console.log('beforeLeave');

    // Header.closeFlyout();
    this.destroy();
  }

  afterLeave(data) {
    ScrollTrigger.getAll().forEach((instance) => {
      if (instance.vars.id != "footer") {
        instance.kill();
      }
    });

    if (this.videos.length) {
      this.videos.forEach((video) => {
        video.destroy();
      });
    }

    // this.videos.forEach((video) => {
    //     video.destroy();
    // });
  }

  beforeEnter(data) {
    scrollSmootherInstance.paused(false);
    // console.log("beforeEnter", data);

    // use a DOM parser to convert a String into an HTMLDocument
    const parser = new DOMParser();
    const dom = parser.parseFromString(data.next.html, "text/html");

    // this will get the .projects div from the next container
    const $fullscreenIntro = $(dom).find('[data-fullscreen-intro="el"]');

    if ($fullscreenIntro.length) {
      scrollSmootherInstance.paused(true);
      const $fullscreenContainer = $("#fullscreenContainer");

      $fullscreenContainer.html($fullscreenIntro);

      // get the newly added fullscreen intro
      // const $newFullscreenIntro = $fullscreenContainer.find('[data-fullscreen-intro="el"]');

      // create a new instance of FullscreenIntro
      new FullscreenIntro($fullscreenIntro);
    }

    // console.dir('beforeEnter', history);
    // console.log("beforeEnter", data);
    window.scrollTo(0, 0);

    const next = data.next.container;
    // console.log('beforeEnter');

    this.initSticky(next);
    this.initToplink(next);
    this.initVideos(next);
    this.initVimeos(next);
    this.initFilter(next);
    this.initForm(next);

    // create a function which should be executed after the images are loaded
    imagesLoaded(next, () => {
      //  console.log("all images are loaded");
      ScrollTrigger.refresh();
    });

    // const imgLoad = imagesLoaded(next);

    // imgLoad.on("always", () => {
    //   console.log("all images are loaded");
    //   ScrollTrigger.refresh();
    // });

    const $videos = $(next).find("video");
    $videos.on("loadeddata", () => {
      ScrollTrigger.refresh();
    });

    this.initScrollAnimations(next);

    this.initMosaic(next);

    this.initFullscreenIntro();
  }

  afterEnter(data) {
    // console.log('afterEnter');
    const sectionId = $(data.next.container).data("section-id");
    ScrollTrigger.refresh();
    

    if (window.location.hash) {
      const hash = window.location.hash;
  
      if (hash) {
        scrollSmootherInstance.scrollTo(hash,true,'top 100px')
      }
    }
  }

  after(data) {
    console.log("after", data);
  }

  initSticky = (scope) => {
    // console.log('initSticky');
    const $sticky = $(scope).find('[data-sticky="el"]');
    if ($sticky.length) {
      new Sticky($sticky);
    }
  };

  initToplink = (scope) => {
    const $toplink = $(scope).find('[data-toplink="el"]');

    // loop through each toplink and create a new instance
    if ($toplink.length) {
      $toplink.each((i, el) => {
        new Toplink($(el));
      });
    }
  };

  initScrollAnimations = (scope) => {
    new ScrollAnimations(scope);
  };

  initMosaic = (scope) => {
    const $mosaic = $(scope).find('[data-mosaic="el"]');
    if ($mosaic.length) {
      $mosaic.each((i, el) => {
        new Mosaic($(el));
      });
    }
  };

  initVideos = (scope) => {
    const $videos = $(scope).find('[data-video="el"]');
    if ($videos.length) {
      const rootEl = document.querySelector('[data-scroll-smooter="wrapper"]');
      $videos.each((i, el) => {
        this.videos.push(new Video($(el), rootEl));
      });
    }
  };

  initFilter = (scope) => {
    const $filter = $(scope).find('[data-filter="el"]');
    if ($filter.length) {
      new Filter($filter);
    }
  };

  initForm = (scope) => {
    const $form = $(scope).find('[data-form="el"]');
    if ($form.length) {
      // dynamically import Form from '../components/form';
      this.form = new Form($form);
    }
  };

  initVimeos = (scope) => {
    const $vimeos = $(scope).find('[data-vimeo="el"]');

    if ($vimeos.length) {
      $vimeos.each((i, el) => {
        new Vimeo($(el));
      });
    }
  };

  destroy() {
    if (this.form) {
      this.form.destroy();
      this.form = null;
    }
  }
}

export default Default;
